import get from 'lodash/get';
import { DEFAULT_COUNTRY_CODE } from 'app/constants';
import IntlShippingService from 'admin/services/api/IntlShippingService';
import StoreAddressesService from 'app/admin/services/storeAddresses/StoreAddressesService';
import countrySort from 'admin/services/utils/countrySort';

export default function getSortedShipToCountries() {
  return Promise.all([
    IntlShippingService.fetchShipToLocations(),
    getPrimaryCountryCode()
  ]).then(([locations, primaryCountryCode]) => ({
    shipToLocations: countrySort(locations, primaryCountryCode),
    defaultCountry: primaryCountryCode
  }));
}

const getPrimaryCountryCode = () => StoreAddressesService.getAddresses()
  .then(addresses => get(addresses, '[0].country', DEFAULT_COUNTRY_CODE));



// WEBPACK FOOTER //
// ./src/app/admin/services/shipToLocations/index.js